import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { PageRequest } from "src/app/support/page-request";
import { Paginated } from "src/app/support/paginated";
import { UUID } from "src/app/support/uuid";
import { TaxRate } from "../../models/tax-rate/tax-rate";
import { TaxRateCreate } from "../../models/tax-rate/tax-rate.create";
import { TaxRateDelete } from "../../models/tax-rate/tax-rate.delete";
import { TaxRateLoad } from "../../models/tax-rate/tax-rate.load";
import { TaxRateUpdate } from "../../models/tax-rate/tax-rate.update";

@Injectable()
export abstract class TaxRateBackend {
  abstract load(request: TaxRateLoad): Observable<TaxRate>;
  abstract list(request: PageRequest): Observable<Paginated<TaxRate>>;
  abstract create(request: TaxRateCreate): Observable<UUID>;
  abstract update(request: TaxRateUpdate): Observable<void>;
  abstract delete(request: TaxRateDelete): Observable<void>;
}
